// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1761) return "static/chunks/d0deef33-793cdd9afae8b550.js";
	if (chunkId === 1551) return "static/chunks/1551-2707cfa579b2ca26.js";
	if (chunkId === 1153) return "static/chunks/1153-5138c15cb086d968.js";
	if (chunkId === 3753) return "static/chunks/3753-f2f834314d57e761.js";
	if (chunkId === 7628) return "static/chunks/7628-75a4a92c9a5c8179.js";
	if (chunkId === 506) return "static/chunks/506-39d7ece5c35e4b5f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1646":"314724838722bc18","2948":"280173546d9a3409","3321":"d97ed88a185eca3e","4358":"62f4c99b653f36e2","5139":"3af505ae0c727fe9","8249":"140aa3ab4ae36da4"}[chunkId] + ".js";
};